import { render, staticRenderFns } from "./SalesStatistic.vue?vue&type=template&id=7076ef6c&"
import script from "./SalesStatistic.vue?vue&type=script&lang=ts&"
export * from "./SalesStatistic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports